import React, { useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const Logo = () => {
  // Animation variants for each chunk
  const chunkVariants = {
    hidden: {
      y: '-100vh', // Start off-screen at the top
      opacity: 0,
    },
    visible: {
      y: 0, // Move to final position
      opacity: 1,
      transition: {
        duration: 1,
        ease: 'easeOut',
      },
    },
  };

  // Ref to manage audio
  const audioRef = useRef(null);

  // Initialize and attempt to play audio
  useEffect(() => {
    const audio = new Audio('/logo.mp3');
    audio.muted = true; // Start muted to attempt autoplay
    audioRef.current = audio;

    // Attempt to play immediately
    const playPromise = audio.play();

    if (playPromise !== undefined) {
      playPromise
        .then(() => {
          // Autoplay started, unmute after a short delay
          setTimeout(() => {
            audio.muted = false;
          }, 100); // Small delay to ensure autoplay is accepted
        })
        .catch(error => {
          console.error('Autoplay failed:', error);
          // Fallback: Attempt to play again after a short delay
          setTimeout(() => {
            audio.muted = false;
            audio.play().catch(err => {
              console.error('Second attempt failed:', err);
            });
          }, 1000);
        });
    }

    // Cleanup: Stop audio when component unmounts
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, []);

  return (
    <div
      className="h-screen w-screen flex items-center justify-center"
      style={{ backgroundColor: '#040404' }}
    >
      <div
        className="relative w-1/2 max-w-md"
        style={{ aspectRatio: '1 / 1' }}
      >
        {/* Top chunk */}
        <motion.div
          variants={chunkVariants}
          initial="hidden"
          animate="visible"
          style={{
            clipPath: 'inset(0 0 66.67% 0)', // Top 33.33%
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          }}
        >
          <img
            src="/logo.png"
            alt="Game Logo Top"
            className="w-full h-full object-contain"
            style={{ position: 'absolute', top: 0, left: 0 }}
          />
        </motion.div>

        {/* Middle chunk */}
        <motion.div
          variants={chunkVariants}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.2 }}
          style={{
            clipPath: 'inset(33.33% 0 33.33% 0)', // Middle 33.33%
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          }}
        >
          <img
            src="/logo.png"
            alt="Game Logo Middle"
            className="w-full h-full object-contain"
            style={{ position: 'absolute', top: 0, left: 0 }}
          />
        </motion.div>

        {/* Bottom chunk */}
        <motion.div
          variants={chunkVariants}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.4 }}
          style={{
            clipPath: 'inset(66.67% 0 0 0)', // Bottom 33.33%
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            overflow: 'hidden',
          }}
        >
          <img
            src="/logo.png"
            alt="Game Logo Bottom"
            className="w-full h-full object-contain"
            style={{ position: 'absolute', top: 0, left: 0 }}
          />
        </motion.div>
      </div>
    </div>
  );
};

export default Logo;